/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostProcessingMemoryForAws extends models.BaseCostProcessingMemory {
    constructor() {
        super();
        this.setDiscriminator("CostProcessingMemoryForAws");
    }

    getFixupPrototypeFunction() { return CostProcessingMemoryForAws.fixupPrototype; }

    static newInstance(model: Partial<CostProcessingMemoryForAws>): CostProcessingMemoryForAws {
        let obj = Object.assign(new CostProcessingMemoryForAws(), model);
        CostProcessingMemoryForAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostProcessingMemoryForAws>): CostProcessingMemoryForAws {
        if (!model) return null;
        return CostProcessingMemoryForAws.newInstance(<CostProcessingMemoryForAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostProcessingMemoryForAws) {
        if (!obj) return;

        models.CostProcessingMemoryForAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostProcessingMemoryForAws): boolean {
        if (models.BaseCostProcessingMemory.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostProcessingMemoryForAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.periods) {
            for (let val of this.periods) {
                models.CostProcessingMemoryForAwsPeriod.fixupPrototype(val);
            }
        }
    }

    /**
     * Processed billing periods
     */
    periods: Array<models.CostProcessingMemoryForAwsPeriod>;

}
